import SurveyGeneralCard from './surveyGeneralCard.container';
export default SurveyGeneralCard;